import { ProductConfig } from "types";

const enConfig: ProductConfig = {
    title: 'Home',
    subtitle: 'Filter 95% Junk Info, AI Chimp Navigation Premium Gems',
    headline: "Skip The Haystack, Grab The Gems",
    description: "Screen out truly innovative products worth trying from a massive amount of products, so that every choice you make is worry-free and reassuring.",
    // submitButton: 'Submit Product',
    details: 'Details',
    introduction: 'Introduction',
    github: 'Github',
    source: 'Source',
    price: 'Price',
    website: 'Website',
    submitter: 'Submitter',
    free: 'Free',
    paid: 'Paid',
    freeandpaid: 'Free & Paid',
    opensource: 'OpenSource',
    date: 'Date',
}

const zhConfig: ProductConfig = {
    title: '首页',
    subtitle: '过滤95%无效信息，AI猩导航直达宝藏精品',
    headline: "跳过大海捞针，直接拿精品",
    description: "从海量产品中筛选出真正值得尝试的创新之作，让你的每一次选择都省心又放心",
    // submitButton: '推荐工具',
    details: '详情',
    introduction: '简介',
    github: '代码',
    source: '来源',
    price: '价格',
    website: '官网',
    submitter: '推荐者',
    free: '免费',
    paid: '付费',
    freeandpaid: '免费&付费',
    opensource: '开源',
    date: '日期',
}

export const AllProductConfigs:{[key: string]: ProductConfig} = {
    en: enConfig,
    zh: zhConfig,
}